import { FieldTypes } from "pages/employer-of-record/components/AutoForm";
import { field, countryIs, REQUIRED } from "./utils";
import * as SOUTH_AFRICA from "../../onboarding/profile-info/form/za/constants.za";

export const southAfricaFields = {
  zaGender: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "zaGender",
    label: "Gender",
    placeholder: "Select Gender",
    options: SOUTH_AFRICA.GENDER_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("ZA"),
    },
    value: () => "",
  }),

  zaMaritalStatus: field({
    type: FieldTypes.select,
    informationType: "identification",
    name: "zaMaritalStatus",
    label: "Marital Status",
    placeholder: "Select Marital Status",
    options: SOUTH_AFRICA.MARITAL_STATUS_OPTIONS,
    validations: REQUIRED,
    scenarios: {
      onboarding: countryIs("ZA"),
    },
    value: () => "",
  }),
};
